<template>
  <div class="deposit-container">
    <!-- 协议弹窗 -->
    <div v-if="xieshow" class="protocolPopUp">
      <div class="title">
        协议区别
        <div @click="openXie" class="close"></div>
      </div>
      <div class="content">
        <img src="/static/image/xieyi.svg" alt="协议说明" />
      </div>
    </div>

    <!-- 支付方式选项卡 -->
    <div class="cardgroup">
      <div class="channels">
        <div 
          @click="changTab(0)" 
          :class="tab == 0 ? 'channel active' : 'channel'" 
          v-if="payWayList.usdt == 1"
        >
          <div class="title">数字货币</div>
          <div class="border"></div>
        </div>
        <div 
          @click="changTab(1)" 
          :class="tab == 1 ? 'channel active' : 'channel'" 
          v-if="payWayList.card == 1"
        >
          <div class="title">人民币</div>
          <div class="border"></div>
        </div>
      </div>
    </div>

    <!-- 数字货币支付（USDT）- 优化布局 -->
    <div class="deposit" v-if="tab == 0">
      <div class="deposit__content">
        <!-- 支付方式：居中显示 -->
        <p class="deposit__title">支付方式</p>
        <!-- 外层容器控制宽度+居中，内层列表横向居中 -->
        <div class="deposit__list-container">
          <ul class="deposit__list">
            <li class="deposit__item active">
              <img src="/static/image/usdt.png" alt="USDT" class="deposit__icon" />
              <p>虚拟币转账</p>
            </li>
          </ul>
        </div>

        <!-- 钱包协议 -->
        <div class="protocol-box">
          <p class="sub-tips">
            钱包协议 
            <img 
              @click="openXie" 
              style="width: 18px; height: 18px; margin-left: 4px;" 
              src="/static/image/xieyi.svg" 
              alt="协议说明" 
            />
          </p>
          <div class="dcbox-protocol">
            <div 
              :class="meyXi == 'TRC20' ? 'protocol-item active' : 'protocol-item'" 
              @click="changMeyXi('TRC20')"
            >
              <span class="circle"></span>
              <span class="text">TRC20</span>
              <img src="/static/image/tuijian.svg" alt="推荐" style="width: 55px; height: 42px;" />
            </div>
            <div 
              :class="meyXi == 'ERC20' ? 'protocol-item active' : 'protocol-item'" 
              @click="changMeyXi('ERC20')"
            >
              <span class="circle"></span>
              <span class="text">ERC20</span>
            </div>
          </div>
        </div>

        <!-- 金额输入 -->
        <div class="deposit-input">
          <p class="deposit-input-title">金额</p>
          <div class="deposit__amount-input-wrapper">
            <input 
              id="amount1" 
              v-model="amount" 
              placeholder="请输入金额" 
              type="text" 
              class="deposit__amount-input" 
              @input="calculateUSDT"
            />
            <span class="deposit__amount-unit">CNY</span>
          </div>
        </div>

        <!-- 汇率提示：分两行显示，刷新按钮右对齐 -->
        <div class="deposit__rate-wrap">
          <!-- 第一行：USDT预估金额 -->
          <p class="deposit__usdt-estimate">
            ≈{{ calculatedUSDT || '0.00' }} USDT 
          </p>
          <!-- 第二行：实时汇率 + 右对齐刷新按钮 -->
          <div class="deposit__rate-row">
            <p class="deposit__cny-tips">
              实时汇率：1 USDT = {{ usdtRate || '0.00' }} CNY 
            </p>
            <span class="refresh-tip" @click="getUSDTRealRate">🔄 刷新</span>
          </div>
        </div>

        <!-- 确认按钮 -->
        <button class="deposit__button" @click="usdtchongBi">确定</button>
      </div>

      <!-- USDT支付弹窗 -->
      <div class="dialog" v-if="ustShow">
        <div class="dialog-cover back" @click="closeUstShow"></div>
        <div class="dialog-content">
          <div class="side">
            <div class="side__header">
              <span>虚拟币存款</span>
              <a href="javascript:void 0;" @click="closeUstShow" class="side__close"></a>
            </div>
            <div class="side__content">
              <div class="scan">
                <div class="scan__amount">
                  <span>存款金额 </span>
                  <span class="scan__amount-number">{{ payInfo.info.amount }} CNY</span>
                </div>
                <div class="scan__amount">
                  <span>预计到账</span>
                  <span class="scan__amount-number">{{ payInfo.info.real_money }} USDT</span>
                </div>
                <p class="scan__title">使用钱包APP扫描二维码完成付款</p>
                <p class="scan__subtitle">可先截屏保存至相册，再使用钱包扫码转账</p>
                
                <!-- 二维码 -->
                <div id="scanQr" class="scan__qr" :title="payInfo.cardlist.mch_id">
                  <img :src="payInfo.cardlist.payimg" alt="支付二维码" style="display: block; max-width: 100%;" />
                </div>

                <!-- 协议提示 -->
                <div class="scan__protocol">{{ payInfo.info.bank }}协议</div>

                <!-- 地址复制 -->
                <div class="scan__link">
                  <span>{{ payInfo.cardlist.mch_id }}</span>
                  <a 
                    @click="doCopy(payInfo.cardlist.mch_id)" 
                    href="javascript:void 0;" 
                    class="scan__copy"
                  >
                    复制
                  </a>
                </div>

                <p class="scan__tips">*请选择正确的钱包协议类型进行存款,否则资产将无法找回</p>
                <button class="scan__button" @click="closeUstShow1">已完成支付</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 人民币支付（银联/支付宝/微信）- 布局优化 -->
    <div class="deposit" v-if="tab == 1">
      <div class="low-special">
        <!-- 支付方式选择 - 图标统一+间距对齐 -->
        <p class="deposit-title">方式</p>
        <div class="pay-way-group">
          <!-- 银联支付 -->
          <div 
            @click="changPayway(1)" 
            :class="pay_way == 1 ? 'deposit-bq yesBorder' : 'deposit-bq noBorder'"
          >
            <div class="deposit-item">
              <div class="deposit-info">
                <div class="icon-wrapper">
                  <span class="icon icon-unionpay"></span>
                </div>
                <div class="pay-text">
                  <div class="main-text">银联支付</div>
                  <div class="sub-text">安全极速到账，存款无忧</div>
                </div>
              </div>
            </div>
          </div>

          <!-- 支付宝支付 -->
          <div 
            @click="changPayway(2)" 
            :class="pay_way == 2 ? 'deposit-bq yesBorder' : 'deposit-bq noBorder'"
            v-if="payWayList.alipay == 1"
          >
            <div class="deposit-item">
              <div class="deposit-info">
                <div class="icon-wrapper">
                  <span class="icon icon-alipay"></span>
                </div>
                <div class="pay-text">
                  <div class="main-text">支付宝支付</div>
                  <div class="sub-text">扫码便捷，实时到账</div>
                </div>
              </div>
            </div>
          </div>

          <!-- 微信支付 -->
          <div 
            @click="changPayway(3)" 
            :class="pay_way == 3 ? 'deposit-bq yesBorder' : 'deposit-bq noBorder'"
            v-if="payWayList.wechat == 1"
          >
            <div class="deposit-item">
              <div class="deposit-info">
                <div class="icon-wrapper">
                  <span class="icon icon-wechat"></span>
                </div>
                <div class="pay-text">
                  <div class="main-text">微信支付</div>
                  <div class="sub-text">微信扫码，安全高效</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 银联支付-收款信息（仅银联显示） -->
        <div class="bank-info" v-if="pay_way == 1">
          <div class="bank-card-item" v-for="(item, index) in cardLis" :key="index">
            <p class="bank-label">收款银行：<span class="bank-value">{{ item.bank_data.bank_name }}</span></p>
            <p class="bank-label">账号：<span class="bank-value">{{ item.bank_no }}</span>
              <img 
                @click="doCopy(item.bank_no)" 
                style="width: 20px; float: right; margin-top: 2px;" 
                src="/static/image/clongicon.png" 
                alt="复制" 
                class="copy-icon"
              />
            </p>
            <p class="bank-label">户名：<span class="bank-value">{{ item.bank_owner }}</span>
              <img 
                @click="doCopy(item.bank_owner)" 
                style="width: 20px; float: right; margin-top: 2px;" 
                src="/static/image/clongicon.png" 
                alt="复制" 
                class="copy-icon"
              />
            </p>
            <p class="bank-label">银行地址：<span class="bank-value">{{ item.bank_address }}</span></p>
          </div>

          <!-- 银联-汇款信息输入 -->
          <p class="deposit-title">汇款姓名</p>
          <div class="amount-wrap">
            <input 
              placeholder="请输入汇款姓名" 
              v-model="bankBox.bank_owner" 
              type="text" 
              maxlength="17" 
              class="amount-input" 
            />
          </div>

          <p class="deposit-title">银行类型</p>
          <div class="amount-wrap">
            <el-select 
              v-model="bankBox.bank" 
              placeholder="请选择银行类型" 
              class="amount-input"
              style="background: #f8f9fa;"
            >
              <el-option 
                v-for="(item, index) in banklist" 
                :key="index" 
                :label="item.bank_name" 
                :value="item.bank_name"
              ></el-option>
            </el-select>
          </div>

          <p class="deposit-title">汇款卡号</p>
          <div class="amount-wrap">
            <input 
              placeholder="请输入汇款卡号" 
              v-model="bankBox.bank_no" 
              type="text" 
              maxlength="20" 
              class="amount-input" 
            />
          </div>

          <p class="deposit-title">开户行</p>
          <div class="amount-wrap">
            <input 
              placeholder="请输入开户行" 
              v-model="bankBox.bank_address" 
              type="text" 
              maxlength="20" 
              class="amount-input" 
            />
          </div>
        </div>

        <!-- 金额输入（所有人民币支付方式共用） -->
        <p class="deposit-title">金额</p>
        <div class="amount-wrap">
          <input 
            placeholder="请输入转账金额" 
            v-model="amount" 
            type="text" 
            maxlength="17" 
            class="amount-input" 
          />
          <div class="amount-unit">CNY</div>
        </div>

        <!-- 温馨提示 -->
        <div class="wxsm-tips">
          <i class="tips-icon"></i>
          <div class="tips-text">
            温馨提示：选择此方式存款需于规定时间内完成，超时则无法到账，如有疑问请联系客服 
            <span @click="$parent.openKefu()" class="kefu-link">联系客服</span>
          </div>
        </div>

        <!-- 确认按钮 -->
        <div class="low-special-btn" @click="chongBi">确定</div>
      </div>

      <!-- 支付宝/微信支付弹窗 -->
      <div class="dialog" v-if="wpShow">
        <div class="dialog-cover back" @click="closeUstShow"></div>
        <div class="dialog-content">
          <div class="side">
            <div class="side__header">
              <span>{{ payInfo.info.paytype }}</span>
              <a href="javascript:void 0;" @click="closeUstShow" class="side__close"></a>
            </div>
            <div class="side__content">
              <div class="gold">
                <img :src="payInfo.cardlist.payimg" alt="支付二维码" class="gold__img" />
                <div class="gold__amount">
                  <span>存款金额 </span>
                  <span class="gold__amount-number">{{ payInfo.info.amount }} CNY</span>
                </div>
                <p class="scan__title">
                  请使用 <span class="c-yellow">{{ payInfo.info.paytype == '支付宝二维码' ? '支付宝' : '微信' }}</span> 扫描二维码，完成付款
                </p>
                <p class="scan__subtitle">
                  可先截屏保存至相册，再使用{{ payInfo.info.paytype == '支付宝二维码' ? '支付宝' : '微信' }}转账
                </p>
                <button class="scan__button" @click="closeUstShow1">已完成支付</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 引入axios用于请求实时汇率（若项目已全局引入可删除）
import axios from 'axios';

export default {
  name: 'deposit',
  data() {
    return {
      tab: 1, // 0:数字货币 1:人民币
      meyXi: 'TRC20', // USDT协议类型
      amount: null, // 存款金额
      pay_way: null, // 人民币支付方式：1-银联 2-支付宝 3-微信
      payInfo: {}, // 支付信息（二维码/地址等）
      ustShow: false, // USDT支付弹窗
      wpShow: false, // 微信/支付宝支付弹窗
      xieshow: false, // 协议弹窗
      baseURL: '', // 基础URL
      cardLis: [], // 银联收款卡列表
      banklist: [], // 银行列表
      bankBox: {}, // 银联汇款信息
      payWayList: {}, // 可用支付方式列表
      usdtRate: null, // USDT实时汇率（1 USDT = X CNY）
      calculatedUSDT: '0.00' // 计算后的USDT金额（CNY转USDT）
    };
  },
  created() {
    this.baseURL = sessionStorage.getItem('baseURL') || '';
    // 初始化数据：并行请求支付方式+银行信息+实时汇率
    this.initData();
  },
  methods: {
    // 初始化数据（合并重复请求，提升性能）
    initData() {
      this.$parent.showLoading();
      // 并行请求：支付方式、银行列表、收款卡、USDT汇率
      Promise.all([
        this.getPayWay(),
        this.getBanklist(),
        this.getcard(),
        this.getUSDTRealRate() // 新增：获取USDT实时汇率
      ]).finally(() => {
        this.$parent.hideLoading();
      });
    },

    // 1. 获取可用支付方式
    getPayWay() {
      return this.$apiFun.get('/api/get_pay_way', {}).then(res => {
        if (res.code === 200) {
          this.payWayList = res.data;
          // 自动选中第一个可用支付方式
          const payWayArr = ['usdt', 'card', 'alipay', 'wxpay'];
          for (const key of payWayArr) {
            if (this.payWayList[key] === 1) {
              this.pay_way = payWayArr.indexOf(key);
              this.tab = key === 'usdt' ? 0 : 1;
              break;
            }
          }
        }
      });
    },

    // 2. 获取银行列表
    getBanklist() {
      return this.$apiFun.post('/api/banklist', {}).then(res => {
        if (res.code === 200) {
          this.banklist = res.data;
        } else {
          this.$parent.showTost(0, res.message);
        }
      });
    },

    // 3. 获取银联收款卡
    getcard() {
      return this.$apiFun.post('/api/getpaybank', {}).then(res => {
        if (res.code === 200) {
          this.cardLis = Array.isArray(res.data) && res.data.length ? res.data : [res.data];
        } else {
          this.$parent.showTost(0, res.message);
        }
      });
    },

    // 4. 新增：获取USDT实时汇率（基于CoinGecko免费API）- 修复可选链语法
    getUSDTRealRate() {
      // CoinGecko免费API：获取Tether（USDT）对CNY的实时汇率
      return axios.get('https://api.coingecko.com/api/v3/simple/price', {
        params: {
          ids: 'tether', // 加密货币ID（USDT对应tether）
          vs_currencies: 'cny', // 目标货币（人民币）
          include_last_updated_at: false // 不包含更新时间，减少返回数据
        },
        timeout: 5000 // 超时时间5秒，避免阻塞
      }).then(response => {
        // 修复：用&&替代可选链（response.data存在 → tether存在 → cny存在）
        if (response.data && response.data.tether && response.data.tether.cny) {
          // 保留2位小数，确保汇率精度
          this.usdtRate = Number(response.data.tether.cny).toFixed(2);
          // 更新已输入金额对应的USDT计算结果
          this.calculateUSDT();
        }
      }).catch(error => {
        console.error('获取USDT实时汇率失败，使用默认汇率', error);
        // 失败时使用默认汇率（避免页面异常）
        this.usdtRate = '7.10'; // 可根据业务调整默认值
        this.calculateUSDT();
      });
    },

    // 5. 新增：计算CNY转USDT的金额（实时更新）
    calculateUSDT() {
      if (!this.amount || !this.usdtRate) {
        this.calculatedUSDT = '0.00';
        return;
      }
      // 计算逻辑：USDT金额 = CNY金额 / USDT汇率（保留2位小数）
      const usdtAmount = (Number(this.amount) / Number(this.usdtRate)).toFixed(2);
      this.calculatedUSDT = usdtAmount;
    },

    // 打开/关闭协议弹窗
    openXie() {
      this.xieshow = !this.xieshow;
    },

    // 关闭支付弹窗
    closeUstShow() {
      this.ustShow = false;
      this.wpShow = false;
      this.payInfo = {};
    },

    // 关闭支付弹窗并跳转资产页
    closeUstShow1() {
      this.closeUstShow();
      this.$parent.goNav('/assets');
    },

    // 切换支付类型选项卡（数字货币/人民币）
    changTab(val) {
      if (this.tab === val) return;
      this.tab = val;
      this.pay_way = val === 0 ? 0 : 1;
      this.amount = null; // 清空金额
      this.calculatedUSDT = '0.00'; // 清空USDT计算结果
    },

    // 切换USDT协议类型
    changMeyXi(val) {
      this.meyXi = val;
    },

    // 切换人民币支付方式（银联/支付宝/微信）
    changPayway(val) {
      if (this.pay_way === val) return;
      this.pay_way = val;
      this.bankBox = {}; // 清空银联信息
      this.amount = null; // 清空金额
    },

    // 人民币支付-提交存款
    chongBi() {
      const payWayArr = ['usdt', 'bank', 'alipay', 'wxpay'];
      const payType = payWayArr[this.pay_way];
      const info = {
        paytype: payType,
        amount: Number(this.amount)
      };

      // 银联支付需额外验证汇款信息
      if (payType === 'bank') {
        const { bank_owner, bank, bank_no, bank_address } = this.bankBox;
        if (!bank_owner) return this.$parent.showTost(0, '请输入存款人姓名');
        if (!bank) return this.$parent.showTost(0, '请选择银行类型');
        if (!bank_no) return this.$parent.showTost(0, '请输入银行卡号');
        if (!bank_address) return this.$parent.showTost(0, '请输入开户行地址');
        // 补充银联信息
        Object.assign(info, { bank, bank_address, bank_no, bank_owner });
      }

      // 金额验证
      if (info.amount <= 0 || isNaN(info.amount)) {
        return this.$parent.showTost(0, '请输入正确的金额（大于0的数字）');
      }

      this.$parent.showLoading();
      this.$apiFun.post('/api/recharge', info).then(res => {
        if (res.code !== 200) {
          return this.$parent.showTost(0, res.message);
        }

        // 银联支付：提交后等待审核
        if (payType === 'bank') {
          this.bankBox = {};
          this.amount = null;
          this.$parent.showTost(1, '操作成功，等待工作人员审核！');
          setTimeout(() => this.$parent.goNav('/assets'), 1500);
          return;
        }

        // 支付宝/微信：获取支付二维码
        this.getpayinfo(res.message, 1);
      }).finally(() => {
        this.$parent.hideLoading();
      });
    },

    // USDT支付-提交存款（使用实时汇率）
    usdtchongBi() {
      let that = this;
      // 1. 金额直接用输入框原始值（字符串类型，如 "100"），不做Number转换
      let info = {
        amount: that.amount, // 关键：与别人一致，传递字符串
        paytype: 'usdt',
        catepay: that.meyXi,
        // 注意：如果后端需要用户ID/Token，这里仍需补充（见差异2）
      };
    
      // 2. 金额验证：先判断是否为空/非数字，再判断是否<=0
      if (!that.amount || isNaN(Number(that.amount))) {
        that.$parent.showTost(0, '请输入有效数字金额');
        return;
      }
      if (Number(that.amount) <= 0) { // 验证时转数字判断，传递时仍用字符串
        that.$parent.showTost(0, '请输入正确金额');
        return;
      }
    
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/recharge', info)
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.amount = null;
            that.getpayinfo(res.message, 0);
          }
        })
        .catch(res => {
          that.$parent.hideLoading();
        })
        .finally(() => { // 补充：无论成功失败，都隐藏loading（避免一直加载）
          that.$parent.hideLoading();
        });
    },

    // 获取支付详情（二维码/地址）
    getpayinfo(depositNo, type) {
      this.$apiFun.post('/api/payinfo', { deposit_no: depositNo }).then(res => {
        if (res.code !== 200) {
          return this.$parent.showTost(0, res.message);
        }
        this.payInfo = res.data;
        // 类型：0-USDT弹窗 1-微信/支付宝弹窗
        type === 0 ? (this.ustShow = true) : (this.wpShow = true);
      });
    },

    // 复制文本（地址/卡号等）
    doCopy(text) {
      const input = document.createElement('input');
      input.value = text;
      input.style.cssText = 'opacity:0; position:fixed; bottom:0; right:0; z-index:-1;';
      document.body.appendChild(input);
      input.select();
      // 兼容不同浏览器的复制API
      if (document.execCommand('copy')) {
        document.execCommand('copy');
        this.$parent.showTost(1, '复制成功！');
      } else {
        // 降级处理：现代浏览器用Clipboard API
        navigator.clipboard.writeText(text).then(() => {
          this.$parent.showTost(1, '复制成功！');
        }).catch(() => {
          this.$parent.showTost(0, '复制失败，请手动复制');
        });
      }
      document.body.removeChild(input); // 清理DOM，避免内存泄漏
    }
  }
};
</script>

<style lang="scss" scoped>
/* 基础容器：白色背景+统一内边距 */
.deposit-container {
  background: #fff;
  min-height: 100vh;
  padding: 15px;
  box-sizing: border-box;
  color: #333;
}

/* 支付方式选项卡：下划线选中态+居中对齐 */
.cardgroup {
  margin-bottom: 25px;
}
.channels {
  display: flex;
  gap: 20px;
  max-width: 400px;
  margin: 0 auto;
}
.channel {
  flex: 1;
  text-align: center;
  cursor: pointer;
  padding: 12px 0;
  border-bottom: 2px solid #eee;
  transition: all 0.3s ease;
}
.channel.active {
  border-bottom-color: #cca352;
}
.channel .title {
  font-size: 16px;
  color: #333;
  font-weight: 500;
  margin-bottom: 3px;
}

/* 存款表单通用样式：卡片式设计+轻微阴影 */
.deposit {
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.04);
  margin-bottom: 20px;
}
.deposit__title {
  font-size: 16px;
  color: #333;
  margin: 0 0 15px;
  font-weight: 500;
}

/* ---------------- USDT支付方式居中调整 ---------------- */
/* 外层容器：控制宽度+水平居中，避免列表占满屏幕 */
.deposit__list-container {
  display: flex;
  justify-content: center;
  margin-bottom: 25px; /* 与下方协议选择保持间距 */
}
/* 内层列表：取消默认flex占满，仅包裹内容 */
.deposit__list {
  display: flex;
  gap: 15px;
  /* 取消原flex:1，避免列表过宽 */
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
}

.deposit__item {
  text-align: center;
  padding: 15px 30px; /* 适当加宽内边距，提升视觉效果 */
  background: #f8f9fa;
  border-radius: 6px;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
}
.deposit__item.active {
  background: #fff;
  border: 1px solid #cca352;
  color: #333;
  box-shadow: 0 2px 8px rgba(204, 163, 82, 0.1);
}
.deposit__icon {
  width: 30px;
  height: 30px;
  margin: 0 auto 8px;
  display: block;
}

/* ---------------- USDT汇率布局调整 ---------------- */
/* 汇率外层容器：控制两行布局的间距 */
.deposit__rate-wrap {
  margin-bottom: 25px;
}
/* 第一行：USDT预估金额 */
.deposit__usdt-estimate {
  font-size: 14px;
  color: #666;
  margin: 0 0 8px; /* 与第二行保持小间距 */
}
/* 第二行：汇率+刷新按钮 横向布局，刷新右对齐 */
.deposit__rate-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/* 实时汇率文本：取消原flex-wrap，确保单行显示 */
.deposit__cny-tips {
  font-size: 14px;
  color: #666;
  margin: 0; /* 清除原margin，由外层容器控制间距 */
}
/* 刷新按钮：保持原有样式，确保右对齐 */
.refresh-tip {
  color: #cca352;
  cursor: pointer;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
  transition: background 0.2s;
  white-space: nowrap; /* 避免刷新按钮换行 */
}
.refresh-tip:hover {
  background: #fff8e6;
}

/* USDT支付-协议选择：推荐标签对齐+选中态高亮 */
.protocol-box {
  margin-bottom: 25px;
}
.sub-tips {
  font-size: 14px;
  color: #333;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}
.dcbox-protocol {
  display: flex;
  gap: 20px;
  background: #f8f9fa;
  padding: 14px 20px;
  border-radius: 8px;
}
.protocol-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #666;
  font-size: 14px;
  padding: 6px 0;
}
.protocol-item.active {
  color: #cca352;
}
.circle {
  width: 16px;
  height: 16px;
  border: 1px solid #ccc;
  border-radius: 50%;
  margin-right: 10px;
  position: relative;
}
.protocol-item.active .circle {
  border-color: #cca352;
}
.protocol-item.active .circle:after {
  content: '';
  width: 8px;
  height: 8px;
  background: #cca352;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* 金额输入：统一高度+内边距 */
.deposit-input-title {
  font-size: 16px;
  color: #333;
  margin-bottom: 12px;
  font-weight: 500;
}
.deposit__amount-input-wrapper {
  position: relative;
  background: #f8f9fa;
  border-radius: 8px;
  height: 50px;
  margin-bottom: 15px;
}
.deposit__amount-input {
  width: 100%;
  height: 100%;
  background: transparent;
  border: none;
  outline: none;
  padding: 0 18px;
  font-size: 16px;
  color: #333;
  box-sizing: border-box;
}
.deposit__amount-input::placeholder {
  color: #999;
  font-size: 14px;
}
.deposit__amount-unit {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  padding: 0 18px;
  background: #eee;
  border-radius: 0 8px 8px 0;
  display: flex;
  align-items: center;
  color: #666;
  font-size: 14px;
}

/* 确认按钮：统一样式+hover效果 */
.deposit__button,
.low-special-btn {
  width: 100%;
  height: 50px;
  background: #cca352;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  transition: background 0.3s ease;
}
.deposit__button:hover,
.low-special-btn:hover {
  background: #b89248;
}

/* -------------- 人民币支付选项布局优化 -------------- */
.pay-way-group {
  display: flex;
  gap: 15px;
  margin-bottom: 25px;
  flex-wrap: wrap;
}
/* 支付选项卡片：统一尺寸+边框区分选中态 */
.deposit-bq {
  flex: 1;
  min-width: 200px;
  max-width: calc(33.33% - 10px);
  padding: 18px;
  border-radius: 8px;
  cursor: pointer;
  background: #f8f9fa;
  border: 1px solid transparent;
  transition: all 0.3s ease;
}
/* 选中态：边框+背景色变化 */
.deposit-bq.yesBorder {
  border-color: #cca352;
  background: #fff;
  box-shadow: 0 2px 8px rgba(204, 163, 82, 0.1);
}
.deposit-bq.noBorder:hover {
  background: #f0f0f0;
}
/* 支付方式内部布局：图标+文字横向对齐 */
.deposit-info {
  display: flex;
  align-items: center;
  gap: 12px;
}
/* 图标容器：统一大小+背景 */
.icon-wrapper {
  width: 45px;
  height: 45px;
  border-radius: 8px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}
/* 支付图标：统一大小 */
.icon {
  width: 45px;
  height: 45px;
  display: inline-block;
}
.icon-unionpay {
  background: url(/static/style/unionpay.cdca8e6e.png) no-repeat center;
  background-size: 45px 45px;
}
.icon-alipay {
  background: url(/static/style/alipay.svg) no-repeat center;
  background-size: 45px 45px;
}
.icon-wechat {
  background: url(/static/image/wechat.png) no-repeat center;
  background-size: 45px 45px;
}
/* 支付文字：主副标题区分 */
.pay-text {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.main-text {
  font-size: 15px;
  color: #333;
  font-weight: 500;
}
.sub-text {
  font-size: 12px;
  color: #666;
}

/* 银联收款信息：标签+值对齐 */
.bank-info {
  margin-bottom: 25px;
}
.bank-card-item {
  background: #f8f9fa;
  padding: 18px;
  border-radius: 8px;
  margin-bottom: 20px;
}
.bank-label {
  font-size: 14px;
  color: #333;
  margin-bottom: 12px;
  line-height: 1.5;
  display: flex;
  align-items: center;
}
.bank-label:last-child {
  margin-bottom: 0;
}
.bank-value {
  color: #666;
  margin-left: 8px;
  flex: 1;
  word-break: break-all;
}
.copy-icon {
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s;
}
.copy-icon:hover {
  opacity: 1;
}

/* 人民币支付-输入框通用样式：统一背景+圆角 */
.amount-wrap {
  position: relative;
  background: #f8f9fa;
  border-radius: 8px;
  height: 50px;
  margin-bottom: 20px;
}
.amount-input {
  width: 100%;
  height: 100%;
  background: transparent;
  border: none;
  outline: none;
  padding: 0 18px;
  font-size: 14px;
  color: #333;
  box-sizing: border-box;
}
.amount-input::placeholder {
  color: #999;
  font-size: 14px;
}
.amount-unit {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  padding: 0 18px;
  display: flex;
  align-items: center;
  color: #666;
  font-size: 14px;
}

/* 温馨提示：图标+文字对齐 */
.wxsm-tips {
  font-size: 13px;
  color: #666;
  background: #fff8e6;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 25px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
.tips-icon {
  width: 18px;
  height: 18px;
  background: url(/static/image/tips-icon.png) no-repeat center;
  background-size: 18px 18px;
  margin-top: 1px;
  flex-shrink: 0;
}
.tips-text {
  line-height: 1.5;
}
.kefu-link {
  color: #cca352;
  cursor: pointer;
  text-decoration: underline;
}

/* 弹窗通用样式：底部弹出+圆角顶部 */
.dialog-cover {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  backdrop-filter: blur(2px);
}
.dialog-content {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #fff;
  border-radius: 16px 16px 0 0;
  z-index: 1000;
  max-height: 85vh;
  overflow-y: auto;
  box-shadow: 0 -3px 15px rgba(0, 0, 0, 0.08);
}
.side__header {
  position: relative;
  height: 55px;
  line-height: 55px;
  text-align: center;
  font-size: 18px;
  color: #333;
  border-bottom: 1px solid #eee;
  font-weight: 500;
}
.side__close {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  width: 22px;
  height: 22px;
  background: url(data:image/png;base64,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) no-repeat center;
  background-size: 22px 22px;
  opacity: 0.7;
  transition: opacity 0.2s;
}
.side__close:hover {
  opacity: 1;
}
.side__content {
  padding: 20px;
}

/* 支付弹窗内容（USDT/微信/支付宝）：居中对齐+间距统一 */
.scan, .gold {
  text-align: center;
}
.scan__amount, .gold__amount {
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
  font-size: 14px;
  color: #666;
}
.scan__amount-number, .gold__amount-number {
  color: #333;
  font-weight: 500;
  font-size: 15px;
}
.scan__title, .gold__title {
  font-size: 16px;
  color: #333;
  margin-bottom: 10px;
  font-weight: 500;
}
.scan__subtitle, .gold__subtitle {
  font-size: 14px;
  color: #666;
  margin-bottom: 25px;
  line-height: 1.5;
}
.scan__qr {
  width: 200px;
  height: 200px;
  margin: 0 auto 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  border-radius: 8px;
  padding: 10px;
}
.scan__qr img, .gold__img {
  max-width: 100%;
  max-height: 100%;
  border-radius: 4px;
}
.scan__protocol {
  display: inline-block;
  padding: 8px 16px;
  background: #f8f9fa;
  color: #333;
  border-radius: 20px;
  font-size: 14px;
  margin-bottom: 25px;
}
.scan__link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;  /* 交给子元素处理 */
  background: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 25px;
  font-size: 12px;
  color: #333;
  overflow: hidden;
}

.scan__text {
  flex: 1;
  padding: 14px 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  word-break: break-all;
}

.scan__link {
  position: relative;
  padding: 14px 18px;
  background: #f8f9fa;
  border-radius: 8px;
  margin-bottom: 25px;
  font-size: 12px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
}
.scan__copy {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 50px;
  background: #cca352;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  font-size: 14px;
  border-radius: 0 8px 8px 0;
}
.scan__tips {
  font-size: 12px;
  color: #999;
  margin-bottom: 25px;
  line-height: 1.5;
  text-align: left;
}

/* 协议弹窗：全屏+滚动内容 */
.protocolPopUp {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 1001;
  display: flex;
  flex-direction: column;
}
.protocolPopUp .title {
  height: 55px;
  line-height: 55px;
  font-size: 18px;
  color: #333;
  border-bottom: 1px solid #eee;
  position: relative;
  padding: 0 20px;
  font-weight: 500;
}
.protocolPopUp .close {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  width: 22px;
  height: 22px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAAEgBckRAAAAAXNSR0IArs4c6QAAA6lJREFUaAXNWbtyFDEQvLXhUyD341dMQGQHRPA5OCKAiID7FduXw6eA65hWbcvSrB6jB3Vc1dVIo5nuaUmr3b3b7Uqfh4eHYzge9dmhDQN3RWc0GHUEQ/c97OFweLM7Ho+v8KVXon+w7QcjJ0fhDDOdn5ERLJ3M1IPSfymAQaEFgHxfpg4JcOhEHbiEKGgj4fHx8bc09/K9ub6+jmLOEBR+JPg7+ldXV+9hNSN87qOp6UdCVCqmHQ4G5CwTd26dclEJ/0J0LU7HIm5Zlm/Ojw4TdSD66/jL5gicGy3JYKJqplRwtChkIoDYvWh7F/TTTc0URm1WGsFARtDaDuPjtq65xJSeupVlw6SRY16/Dm7KudLV2SDLgr30/Pz8E6iypV/L8v/RDK19AceuuEGeW7fgInNYvUQhsAA5ldHG6CVKAbtKqYAdWitRCZhYkQI6aXNEFmBiFAkYpIlWf3UnIW5z6RA0tDw4Q5+0b0CsfJtuUUFuKrSi0q5LEuSAdXkWoojACtxC5Ah6gU1ECBICd4eQubzTST19Tp0cO/cuv/XeZiElJk9H5Jj2dQ2c1SPu/Pz87Zm/ecq+XteihpEdD8ERdHFx8WvaImtwXht+m47spBw4VHgCdHpISuAbglaSGniSwEpiAc8S1Eis4EWCHEkLeJUgRSI+97SAMW5FtHOfaBflgtTucmEWcASa7mgC5l4BggL21uenqgI95yGJ5Vm3qECDY1qEwD3qijWdXVkFKXBOi1qT4imcJCiBc4qsJBsCC3gLSUTQAm4l8QQ94BYSRzACXiNZZoCXSMKbvulsIVjOhruLN3337GI9W3LA9OPq5oOEv+nL0/NnmaqPCMLg5eXlB15UTDy1xVI+PT19EXuLWqS+e5mUT9FLpipyj0P01ELWPYjfdfxtiHViicOrIBkkwScRUio8rMmfE1BlTULsv/q01hAJYFGtIMwbsb2cSQEspBeU+RY7ylEUwAJGSYgT2lmYJgEknkE6A4P1wDYJYGJPET055CvZLgEEtBSF2PVnps05LkPDR/SQAKMQhoV2uHCCTRFAsMqKIGxa4eScJsBQPDmnihgWUCncv8Kx+sBOEdItoFZ4+CDYEhsINDWbBYwUM5KbU2MWMJN8JlZVwEwyPYszsLMCZoDrgnP9Ea6NgBGwXIFWfw+3F9CTbC2sNa6lFidAnlW+StJtgmjKWZ3ANblKQvDjgxzVd7mX+pMWrtXlhOCl3sfi7yH+ReSd/2FD1/kXqyYUaF3HgagAAAAASUVORK5CYII=) no-repeat center;
  background-size: 22px 22px;
  opacity: 0.7;
  transition: opacity 0.2s;
}
.protocolPopUp .close:hover {
  opacity: 1;
}
.protocolPopUp .content {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}
.protocolPopUp .content img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 0 auto;
  display: block;
}

/* 高亮色（按钮/选中态）：统一金色系 */
.c-yellow {
  color: #cca352;
}

/* 响应式适配：小屏幕优化 */
@media (max-width: 768px) {
  .pay-way-group {
    flex-direction: column;
    gap: 12px;
  }
  .deposit-bq {
    max-width: 100%;
    min-width: 100%;
  }
  .scan__qr {
    width: 160px;
    height: 160px;
  }
  .channels {
    max-width: 100%;
  }
  /* USDT支付方式：小屏幕保持居中，适当减小内边距 */
  .deposit__item {
    padding: 12px 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/main/deposit.vue